export const REPORT_TYPES = {
  STATS: 'stats',
  REPORTS: 'reports',
  DATABASE: 'database',
  EXPORTS: 'exports',
}

export const reportOptions = [
  { value: REPORT_TYPES.STATS, visitorAccess: true },
  // TBA
  { value: REPORT_TYPES.REPORTS, visitorAccess: false },
  { value: REPORT_TYPES.DATABASE, visitorAccess: false },
  // {value: REPORT_TYPES.EXPORTS, visitorAccess: false},
]
